import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Api from '../../../services/Api';
import HelperGeneral from '../../../helpers/HelperGeneral';
import ReactHtmlParser from 'react-html-parser';
import {faAngleLeft, faHouse} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Spin} from 'antd';
import CategorySideBar from '../../partials/CategorySideBar';
import UserInfo from "../../auth/UserInfo";

class Product extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            filterShow: [],
            info: {},
            width: window.innerWidth,
            link: "/kategori/daily/temel-bakim",
            loading: false,
            priceListInfo: {}
        }

        this._lastViewedItemKey = null;
    }

    updateWidth = () => {
        this.setState({width: window.innerWidth});
    };

    componentDidMount() {
        const product_id = this.props?.match?.params?.product_id;
        if (!product_id) {
            HelperGeneral.pageChange(this, '/home');
            return null;
        }
        window.scroll(0, 0);
        window.addEventListener('resize', this.updateWidth);

        this.setPriceListLocalStorage();
        this.getProduct(product_id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const product_id = this.props?.match?.params?.product_id;
        if (prevProps?.match?.params?.product_id !== product_id) {
            this.getProduct(product_id);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    getProduct(product_id) {
        this.setState({loading: true});
        Api.getProductDetail(product_id).then((e) => {
            this.setState({
                info: e?.data,
            }, () => {
                try {
                    const info = e?.data || {};
                    const productId = info?.id || info?.product_id || info?.productId || null;
                    const viewKey = String(productId || info?.slug || product_id || '');
                    if (viewKey && this._lastViewedItemKey === viewKey) {
                        // no-op (avoid duplicate)
                    } else if (typeof window.soulTrackEvent === 'function' && (productId != null || info?.product_code || info?.code)) {
                        this._lastViewedItemKey = viewKey;
                        const productCodeRaw = info?.product_code || info?.code || productId || product_id;
                        const productCode = (typeof window.normalizeProductCode === 'function')
                            ? window.normalizeProductCode(productCodeRaw)
                            : String(productCodeRaw || '').padStart(15, '0');
                        window.soulTrackEvent({
                            eventName: 'view_item',
                            type: 'detay',
                            ecommerce: {
                                currency: 'TRY',
                                value: '0',
                                items: [{
                                    code: productCode,
                                    item_name: info?.name || '',
                                    quantity: 1,
                                    item_image: info?.images?.[0]?.w600x || info?.images?.[0]?.raw || undefined,
                                    url: info?.slug ? (`/product/${info.slug}`) : undefined,
                                    category_names: info?.categoryInfos?.all?.map(c => c?.name).filter(Boolean).join('>') || undefined,
                                }],
                            },
                        });
                    } else if (productId != null || info?.product_code || info?.code) {
                        this._lastViewedItemKey = viewKey;
                        setTimeout(() => {
                            try {
                                if (typeof window.soulTrackEvent !== 'function') return;
                                const productCodeRaw = info?.product_code || info?.code || productId || product_id;
                                const productCode = (typeof window.normalizeProductCode === 'function')
                                    ? window.normalizeProductCode(productCodeRaw)
                                    : String(productCodeRaw || '').padStart(15, '0');
                                window.soulTrackEvent({
                                    eventName: 'view_item',
                                    type: 'detay',
                                    ecommerce: {
                                        currency: 'TRY',
                                        value: '0',
                                        items: [{
                                            code: productCode,
                                            item_name: info?.name || '',
                                            quantity: 1,
                                            item_image: info?.images?.[0]?.w600x || info?.images?.[0]?.raw || undefined,
                                            url: info?.slug ? (`/product/${info.slug}`) : undefined,
                                            category_names: info?.categoryInfos?.all?.map(c => c?.name).filter(Boolean).join('>') || undefined,
                                        }],
                                    },
                                });
                            } catch (e2) { /* best-effort */ }
                        }, 0);
                    }
                } catch (err) {
                    // best-effort
                }
                this.setState({loading: false});
            })
        }).catch((e) => {
            this.setState({loading: false})
            HelperGeneral.alert(e);
            HelperGeneral.pageChange(this, '/home');
        })
    }

    getPriceList() {
        Api.getPriceList().then((e) => {
            const expiry = Date.now() + 15 * 60 * 1000;
            const data = {
                value: e?.data,
                expiry
            };

            localStorage.setItem("priceListInfo", JSON.stringify(data));
            this.setState({priceListInfo: e?.data});
        }).catch((e) => {
            HelperGeneral.alert(e);
        })
    }

    setPriceListLocalStorage() {
        const stored = localStorage.getItem("priceListInfo");

        if (stored) {
            const parsed = JSON.parse(stored);

            if (Date.now() > parsed?.expiry) {
                localStorage.removeItem("priceListInfo");
                this.getPriceList();
            } else {
                this.setState({priceListInfo: parsed?.value});
            }
        } else {
            this.getPriceList();
        }
    }

    render() {
        const {info, loading, width, priceListInfo} = this.state;

        return (
            <div className={'product-detail pb-0 pb-sm-5'}>
                <Container>
                    <Row>
                        {
                            width > 991 && (
                                <Col sm={6} lg={3} className={'mt-3'}>
                                    <Row>
                                        <CategorySideBar productDetailSlug={info?.categoryInfos?.all[0]?.slug}/>
                                    </Row>
                                </Col>
                            )
                        }
                        <Col xs={12} lg={9} className={'mt-3 '}>
                            <Spin spinning={loading}>
                                <Row>
                                    <Col xs={12}>
                                        <Breadcrumb>
                                            <a onClick={() => window.history.back()}>
                                                <FontAwesomeIcon
                                                    icon={faAngleLeft}
                                                    className={'me-3'}
                                                    style={{
                                                        color: '#52585B',
                                                        fontSize: width > 767 ? 18 : 14,
                                                        paddingTop: 2,
                                                    }}
                                                />
                                            </a>
                                            <Breadcrumb.Item linkAs={Link} linkProps={{to: '/home'}}>
                                                <FontAwesomeIcon
                                                    icon={faHouse}
                                                    className={'me-0'}
                                                    style={{
                                                        color: '#52585B',
                                                        fontSize: width > 767 ? 18 : 14,
                                                        paddingTop: 0,
                                                    }}
                                                />
                                            </Breadcrumb.Item>
                                            <Breadcrumb.Item linkAs={Link} linkProps={{to: this.state.link}}>Ürünler</Breadcrumb.Item>
                                            <Breadcrumb.Item linkAs={Link} linkProps={{to: '/kategori/' + info?.categoryInfos?.all[0]?.slug}}>
                                                {info?.categoryInfos?.all[0]?.name?.split("/")[0].trim()}
                                            </Breadcrumb.Item>
                                            <Breadcrumb.Item active>{info?.name}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </Col>
                                    <Col xs={12} className={'mt-2 mb-3'}>
                                        <Row>
                                            <Col xs={12} lg={6} style={{backgroundColor: 'transparent'}}>
                                                <Carousel
                                                    showArrows={true}
                                                    showIndicators={false}
                                                    showStatus={false}
                                                    autoPlay={true}
                                                    centerSlidePercentage={true}
                                                    showThumbs={info?.images?.length > 1}
                                                >
                                                    {
                                                        (info?.images && info?.images?.length > 0) ? (
                                                            info?.images?.map((v, i) => (
                                                                <div key={i}>
                                                                    <img
                                                                        src={v?.w600x ?? v?.raw}
                                                                        alt={info?.name}
                                                                        className={'product-image rounded'}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div>
                                                                <img
                                                                    src={require('../../../assets/images/png/default-product.png')}
                                                                    alt={info?.name}
                                                                    className={'product-image rounded'}
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                </Carousel>
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <h3 className={'frame pt-0 title'}>{info?.name}</h3>
                                                {
                                                    info?.brief_description && (
                                                        <div className={'alt_tag frame mt-3'}>{info?.brief_description?.split(/\r?\n/)[0]}</div>
                                                    )
                                                }
                                                <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                                    {
                                                        (UserInfo.info('user_roles_id') === 4 || UserInfo.info('user_roles_id') === 6) ? (
                                                            <div className={'frame point mb-3'}>
                                                                <div className={'gift'}>
                                                                    <span>{HelperGeneral.formatPoint(info?.earn_points)}</span>
                                                                    <img
                                                                        src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                        className={'q-point-logo'}
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : (info?.gift_product === 1 && info?.gift_point > 0) && (
                                                            <div className={'frame point mb-3'}>
                                                                <div className={'gift'}>
                                                                    <span>{HelperGeneral.formatPoint(info?.gift_point)}</span>
                                                                    <img
                                                                        src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                        className={'q-point-logo'}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        ((UserInfo.info('user_roles_id') === 4 || UserInfo.info('user_roles_id') === 6) && priceListInfo?.products && info?.id) && (
                                                            <div className={'frame point mb-3'}>
                                                                <div className={'gift'}>
                                                                    <span>{HelperGeneral.formatMoneyTL(priceListInfo?.products[info?.id]?.price)}</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                {
                                                    info?.descriptions?.length > 0 && info?.descriptions[3] && info?.descriptions[3]?.description && (
                                                        <div className={'brief_description frame mb-3'}>
                                                            {ReactHtmlParser(info?.descriptions[3]?.description)}
                                                        </div>
                                                    )
                                                }
                                                <div className={'frame link'}>
                                                    <span>Ayrıntılı bilgi için: </span> <a className={'redirect-link'} target={'_blank'} href={'https://shiniq.com/'}>https://shiniq.com/</a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Spin>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default withRouter(Product);
